/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import generalSettingsTemplate from '../admin/general-settings.tpl.html';
import outgoingMailSettingsTemplate from '../admin/outgoing-mail-settings.tpl.html';
import smsSettingsTemplate from '../admin/sms-settings.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function AdminRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.settings', {
            url: '/settings',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            redirectTo: 'home.settings.general',
            ncyBreadcrumb: {
                label: '{"icon": "settings", "label": "admin.system-settings"}'
            }
        })
        .state('home.settings.general', {
            url: '/general',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: generalSettingsTemplate,
                    controllerAs: 'vm',
                    controller: 'AdminController'
                }
            },
            data: {
                key: 'general',
                pageTitle: 'admin.general-settings'
            },
            ncyBreadcrumb: {
                label: '{"icon": "settings_applications", "label": "admin.general"}'
            }
        })
        .state('home.settings.outgoing-mail', {
            url: '/outgoing-mail',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: outgoingMailSettingsTemplate,
                    controllerAs: 'vm',
                    controller: 'AdminController'
                }
            },
            data: {
                key: 'mail',
                pageTitle: 'admin.outgoing-mail-settings'
            },
            ncyBreadcrumb: {
                label: '{"icon": "mail", "label": "admin.outgoing-mail"}'
            }
        })
        .state('home.settings.sms', {
            url: '/sms',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: smsSettingsTemplate,
                    controllerAs: 'vm',
                    controller: 'AdminController'
                }
            },
            data: {
                key: 'sms',
                pageTitle: 'admin.sms-settings'
            },
            ncyBreadcrumb: {
                label: '{"icon": "sms", "label": "admin.sms"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/admin/admin.routes.js